import { Alert, Button, Card, Form, message, Select, Spin } from "antd";
import React from "react";
import { sanitizeFieldName } from "../../util/methods";
import SubList from "../../components/PreVerificationCreateSubList";
import MasterModal from "../../components/MasterModal";
import InlineCreateMasterModal from "../../components/InlineCreateMasterModal";
import "./style.css";
import { geolocated } from "react-geolocated";

let cnt = 0,
    payload = {};

class Create extends React.Component {
    constructor(props) {
        super(props);
        this.child = React.createRef();
        this.meter = React.createRef();
        this.qrCode = React.createRef();
        this.state = {
            loading: false,
            subData: [{}],
            documentData: {},
            formData: {},
            latitude: 0,
            longitude: 0,
            tempAssetCode: "",
            tempQrCode: "",
            userName: "",
            checked: false,
            uploaded: false,
            uploadedCount: 0,
            resourceData: [],
            qrAcceptVisible: false,
            createdAuditVouchers: [],
        };
    }

    mergeUniqueOptions = (baseOptions = [], createdOptions = []) => {
        const merged = [...(baseOptions || [])];
        (createdOptions || []).forEach((created) => {
            if (!created || !created._id) {
                return;
            }
            const exists = merged.find((item) => `${item && item._id}` === `${created._id}`);
            if (!exists) {
                merged.push(created);
            }
        });
        return merged;
    };

    getAuditVoucherOptions = () => {
        const { filters } = this.props;
        const baseOptions = filters && filters.auditVoucher && filters.auditVoucher.data && filters.auditVoucher.data.data || [];
        return this.mergeUniqueOptions(baseOptions, this.state.createdAuditVouchers);
    };

    handleAuditVoucherCreated = (createdAuditVoucher) => {
        if (!createdAuditVoucher || !createdAuditVoucher._id) {
            return;
        }
        this.setState((prevState) => {
            const exists = (prevState.createdAuditVouchers || []).find((item) => `${item._id}` === `${createdAuditVoucher._id}`);
            if (exists) {
                return null;
            }
            return {
                createdAuditVouchers: [...(prevState.createdAuditVouchers || []), createdAuditVoucher],
            };
        });
        this.props.form.setFieldsValue({
            auditVoucher: createdAuditVoucher._id,
        });
    };

    // When a voucher carries an audit scope, drive the form's location /
    // sub-location from it. Those fields are then disabled in render (derived from
    // the selected voucher), so the PV always opens against the voucher's scope.
    handleAuditVoucherSelect = (voucherId) => {
        const voucher = (this.getAuditVoucherOptions() || []).find(o => `${o && o._id}` === `${voucherId}`);
        const idOf = (v) => (v && (v._id || v)) || undefined;
        const locationId = voucher && idOf(voucher.location);
        const clientId = voucher && idOf(voucher.client);

        const next = {};
        if (locationId) next.location = locationId;
        if (clientId) next.client = clientId;
        if (Object.keys(next).length) {
            this.props.form.setFieldsValue(next);
        }

        // Auto-fill bypasses the manual onSelect handlers, so keep the
        // duplicate-report check working.
        if (locationId) {
            payload.location = locationId;
            payload.client = clientId;
            this.props.onCheck(payload);
        }
    };

    changeQrAcceptVisible = (isVisible) => {
        this.setState({
            qrAcceptVisible: isVisible
        })
    }

    selectedLocation = e => {
        cnt++;
        if (cnt >= 2) {
            this.sendValues();
        }
    };

    selectedSubLocation = e => {
        cnt++;
        if (cnt >= 2) {
            this.sendValues();
        }
    };

    sendValues = async () => {
        payload.location = this.props.form.getFieldValue("location");
        payload.client = this.props.form.getFieldValue("client");
        await this.props.onCheck(payload);
    };

    componentDidMount = async () => {
        const { match, fetch } = this.props;
        if (match.params && match.params.id) {
            fetch(match.params.id);
        }

        const user = JSON.parse(localStorage.getItem("user"));
        if (user && user.name) {
            this.setState({ username: user.name });
        }
        if (user && user.roles.length > 0) {
            for (const role of user.roles) {
                if (
                    role &&
                    role.disallowCreationOfAssetStockTakingReportHavingSameLocationAndSubLocation
                ) {
                    this.setState({
                        disallowCreationOfAssetStockTakingReportHavingSameLocationAndSubLocation: true
                    });
                    break;
                }
            }
        }
    };

    componentWillReceiveProps(nextProps, nextContext) {
        if (
            nextProps &&
            nextProps.data &&
            JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)
        ) {
            this.setState({ subData: nextProps.data.assetDetails });
        }

        if (
            nextProps &&
            nextProps.match &&
            nextProps.match.params &&
            JSON.stringify(nextProps.match.params.id) !==
            JSON.stringify(this.props.match.params.id)
        ) {
            nextProps &&
                nextProps.fetch &&
                nextProps.fetch(nextProps.match.params.id);
        }

        if (nextProps && nextProps.coords) {
            this.setState({
                latitude: nextProps.coords.latitude || "",
                longitude: nextProps.coords.longitude || ""
            });
        }

        if (
            nextProps &&
            nextProps.tempCodeData &&
            nextProps.tempCodeData.assetDetails &&
            nextProps.tempCodeData.assetDetails.length &&
            nextProps.tempCodeData.assetDetails[
            nextProps.tempCodeData.assetDetails.length - 1
            ] &&
            nextProps.tempCodeData.assetDetails[
                nextProps.tempCodeData.assetDetails.length - 1
            ].tempAssetCode &&
            JSON.stringify(nextProps.tempCodeData) !==
            JSON.stringify(this.props.tempCodeData)
        ) {
            this.setState({
                tempAssetCode:
                    nextProps.tempCodeData.assetDetails[
                        nextProps.tempCodeData.assetDetails.length - 1
                    ].tempAssetCode
            });
        }
    }

    updateUploadedState = () => {
        this.setState({ uploaded: true });
    };

    onClick = () => {
        this.child.current.clearDocumentData();
        if (this.props.title === "CREATE") {
            this.setState({ documentData: {} });
        }
    };

    handleSubmitWithDocuments = (e, save = false) => {
        const { match } = this.props;
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (err) {
                return console.log(err);
            }
            const values2 = this.props.form.getFieldsValue();
            const data = { ...values2 };
            const { coords } = this.props;
            data["status"] = "OPEN";
            data["latitude"] = this.state.latitude || 0;
            data["longitude"] = this.state.longitude || 0;

            if (this.state.documentData) {
                data.assetDetails[0]["fileData"] = [];
                data.assetDetails[0]["fileData"] = this.state.documentData;
            }

            if (this.props.title === "CREATE" || this.props.title === "EDIT") {
                data._id =
                    (this.props.tempCodeData && this.props.tempCodeData["_id"]) || null;
            }

            if (
                this.state.uploadedCount > 0 &&
                this.props.tempCodeData &&
                this.props.tempCodeData["_id"]
            ) {
                data._id = this.props.tempCodeData["_id"] || null;
                data.assetDetails[0].latitude = this.state.latitude || 0;
                data.assetDetails[0].longitude = this.state.longitude || 0;
            } else if (
                this.state.uploadedCount > 0 &&
                this.props.title === "CREATE" &&
                this.props.record &&
                this.props.record["_id"]
            ) {
                data.assetDetails[0].latitude = this.state.latitude || 0;
                data.assetDetails[0].longitude = this.state.longitude || 0;
                data._id = this.props.record["_id"] || null;
            }

            if (
                this.state.uploadedCount > 0 &&
                (this.props.title === "CREATE" || this.props.title === "EDIT")
            ) {
                this.props.onUpdate(
                    data,
                    data._id,
                    this.state.checked,
                    true,
                    false,
                    save
                );
            } else {
                this.props.onSubmitWithDocument(
                    data,
                    this.state.checked,
                    true,
                    false,
                    save
                );
            }
            this.props.form.resetFields("assetDetails");
            this.child.current.clearDocumentData();
            this.child.current.clearKeys2Data();
            let count = this.state.uploadedCount;
            this.setState({
                uploadedCount: count + 1,
                tempAssetCode: "",
                tempQrCode: "",
                documentData: {},
                qrAcceptVisible: false,
            });
            if (this.state.checked) {
                this.setState({ checked: false });
            }
        });
    };

    handleSubmit = e => {
        console.log(`On submit`);
        const { match } = this.props;
        e.preventDefault();

        this.props.form.validateFields((err, values) => {
            if (err) {
                return console.log(err);
            }
            if (
                values &&
                values.assetDetails &&
                values.assetDetails[0] &&
                values.assetDetails[0].qty &&
                parseInt(values.assetDetails[0].qty) <= 1
            ) {
                // console.log('entered inside');
                return message.error(
                    "Number of Quantity should be greater than 1 ..! "
                );
            }
            if (values && values.assetDetails && values.assetDetails.length) {
                values.assetDetails.forEach(itm => {
                    itm.assetModel = itm.assetModel.split("-")[0];
                    // console.log(itm.assetModel);
                });
            }
            const data = Object.assign({}, values);
            data["latitude"] = this.state.latitude || 0;
            data["longitude"] = this.state.longitude || 0;

            if (
                this.props.title === "EDIT" &&
                this.state.uploadedCount > 0 &&
                this.props.match.params &&
                this.props.match.params.id
            ) {
                data._id = this.props.match.params.id || null;
            } else if (
                this.state.uploadedCount > 0 &&
                this.props.title === "CREATE" &&
                this.props.record &&
                Object.keys(this.props.record)
            ) {
                data._id = (this.props.record && this.props.record["_id"]) || null;
            } else if (
                this.state.uploadedCount > 0 &&
                (this.props.title === "CREATE" || this.props.title === "EDIT") &&
                this.props.tempCodeData &&
                Object.keys(this.props.tempCodeData)
            ) {
                data._id =
                    (this.props.tempCodeData && this.props.tempCodeData["_id"]) || null;
            }

            if (this.state.uploadedCount > 0 && data._id === null) {
                return message.error("No Record Found to update");
            }
            // console.log(data);
            if (
                this.state.uploadedCount > 0 &&
                (this.props.title === "CREATE" || this.props.title === "EDIT")
            ) {
                this.props.onTempCodeUpdate(data._id, data, this.state.checked, true);
            } else if (
                this.props.title === "EDIT" &&
                this.props.match &&
                this.props.match.params &&
                this.props.match.params.id
            ) {
                this.props.onTempCodeUpdate(
                    this.props.match.params.id,
                    data,
                    this.state.checked,
                    true
                );
            } else if (this.props.title === "EDIT") {
                this.props.onTempCodeUpdate(
                    this.props.data._id,
                    data,
                    this.state.checked,
                    true
                );
            } else {
                this.props.onSubmit(data, false);
            }
        });
    };

    handleDone = e => {
        this.handleSubmitWithDocuments(e, true);
    };

    editEarlier = id => {
        this.props.viewEarlier(id);
    };

    getDocumentData = data => {
        //this.props.form.setFieldsValue({[`assetDetails[0][fileData]`]: data });
        this.setState({ documentData: data });
    };

    onChangeCountable = e => {
        if (e.target.checked) {
            this.setState({ checked: true });
        } else if (!e.target.checked) {
            this.setState({ checked: false });
        }
    };

    componentWillUnmount() {
        if (this.props.title === "CREATE") {
            this.props.clearData();
        }
        cnt = 0;
        payload = {};
    }

    handleExit = () => {
        if (this.props.tempCodeData && this.props.tempCodeData._id) {
            this.props.history.push(
                `/pre-verification/view/${this.props.tempCodeData &&
                this.props.tempCodeData._id}`
            );
        } else if (this.props.record && this.props.record._id) {
            this.props.history.push(
                `/pre-verification/view/${this.props.record && this.props.record._id}`
            );
        } else {
            this.props.history.push(`/pre-verification`);
        }
    };

    onConfirmAlert = e => {
        this.props.history.push(`/pre-verification/view/${this.props.warning.id}`);
    };

    onDeclineAlert = () => {
        this.props.history.push(`/pre-verification`);
    };

    render() {
        const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;
        const {
            data,
            loading,
            filters,
            title,
            resource,
            tempAssetCodeData
        } = this.props;
        const { tempAssetCode } = this.state;
        const auditVoucherOptions = this.getAuditVoucherOptions();

        // Lock location / sub-location when the selected voucher defines that scope.
        const idOf = (v) => (v && (v._id || v)) || undefined;
        const selectedVoucherId = getFieldValue('auditVoucher') || (data && idOf(data['auditVoucher']));
        const selectedVoucher = (auditVoucherOptions || []).find(o => `${o && o._id}` === `${selectedVoucherId}`);
        const lockLocation = !!(selectedVoucher && idOf(selectedVoucher.location));
        const lockClient = !!(selectedVoucher && idOf(selectedVoucher.client));

        return (
            <Spin spinning={this.state.loading || loading}>
                <Card
                    className={`gx-card-metrics`}
                    title={`${title} ${sanitizeFieldName(resource)}`}
                >
                    {this.props.warning &&
                        this.props.warning.code === 201 &&
                        this.props.title === "CREATE" ? (
                        <Alert
                            description={this.props.warning.message}
                            type="error"
                            onClose={this.onConfirmAlert}
                            closeText="Edit Earlier Report"
                            closable={false}
                        />
                    ) : (
                        <> </>
                    )}
                    <br />
                    <Form onSubmit={this.handleSubmit} layout="vertical">
                        <div className={"asset-stock-taking"}>
                            <Form.Item key={'auditVoucher'} label={sanitizeFieldName('auditVoucher')}>
                                {getFieldDecorator('auditVoucher', {
                                    rules: [{ required: true, message: `${sanitizeFieldName('auditVoucher')} is required!` }],
                                    initialValue: data && data['auditVoucher'] && (data['auditVoucher']._id || data['auditVoucher']),
                                })(<Select
                                    showSearch
                                    style={{ width: '80%' }}
                                    placeholder="Please select"
                                    onChange={this.handleAuditVoucherSelect}
                                    filterOption={(input, option) =>
                                        (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
                                    }
                                    disabled={(title === 'EDIT' && filters['auditVoucher'] && filters['auditVoucher'].options.disabledOnEdit) || false}
                                >
                                    {(auditVoucherOptions || []).map(itm =>
                                        <Select.Option key={itm._id} value={itm._id}>{itm.voucherNo}</Select.Option>)}
                                </Select>)}
                                {
                                    filters['auditVoucher'] && filters['auditVoucher'].options && filters['auditVoucher'].options.master ?
                                        <InlineCreateMasterModal
                                            item={filters['auditVoucher'].options.ref || 'AuditVoucher'}
                                            onCreated={this.handleAuditVoucherCreated}
                                            triggerStyle={{
                                                margin: '0',
                                                marginTop: '0',
                                                marginLeft: '10px',
                                                width: 'calc(100% - 10px)'
                                            }}
                                        /> : ''
                                }
                            </Form.Item>
                            <Form.Item key={"location"} label={sanitizeFieldName("location")}>
                                {getFieldDecorator("location", {
                                    rules: [
                                        {
                                            required: true,
                                            message: `${sanitizeFieldName("location")} is required!`
                                        }
                                    ],
                                    initialValue:
                                        data &&
                                        data["location"] &&
                                        (data["location"]._id || data["location"])
                                })(
                                    <Select
                                        showSearch
                                        onSelect={this.selectedLocation}
                                        style={{ width: "75%" }}
                                        placeholder="Please select location"
                                        filterOption={(input, option) =>
                                            (option.props.children + "")
                                                .toLowerCase()
                                                .indexOf((input + "").toLowerCase()) >= 0
                                        }
                                        disabled={
                                            lockLocation ||
                                            (title === "CREATE" &&
                                                (this.state.tempAssetCode !== "" ||
                                                    this.state.uploadedCount > 0)
                                                ? true
                                                : (title === "EDIT" &&
                                                    filters["location"] &&
                                                    filters["location"].options.disabledOnEdit) ||
                                                false)
                                        }
                                    >
                                        {filters["location"] &&
                                            filters["location"]["data"] &&
                                            filters["location"]["data"]["data"].map(itm => (
                                                <Select.Option key={itm._id} value={itm._id}>
                                                    {itm.name}
                                                </Select.Option>
                                            ))}
                                    </Select>
                                )}
                                {filters["location"] &&
                                    filters["location"].options &&
                                    filters["location"].options.master ? (
                                    <MasterModal
                                        resource={resource}
                                        item={filters["location"].options.ref}
                                        title={"CREATE"}
                                    />
                                ) : (
                                    ""
                                )}
                            </Form.Item>
                            <Form.Item
                                key={"client"}
                                label={sanitizeFieldName(
                                    filters["client"] && filters["client"].options.label
                                        ? filters["client"].options.label
                                        : "Sub Location"
                                )}
                            >
                                {getFieldDecorator("client", {
                                    rules: [
                                        {
                                            required: filters["client"] && filters["client"].required,
                                            message: `${sanitizeFieldName(
                                                filters["client"] && filters["client"].options.label
                                                    ? filters["client"].options.label
                                                    : "Sub Location"
                                            )} is required!`
                                        }
                                    ],
                                    initialValue:
                                        data &&
                                        data["client"] &&
                                        (data["client"]._id || data["client"])
                                })(
                                    <Select
                                        showSearch
                                        onSelect={this.selectedSubLocation}
                                        style={{ width: "75%" }}
                                        placeholder="Please select sub location"
                                        filterOption={(input, option) =>
                                            (option.props.children + "")
                                                .toLowerCase()
                                                .indexOf((input + "").toLowerCase()) >= 0
                                        }
                                        disabled={
                                            lockClient ||
                                            (title === "CREATE" &&
                                                (this.state.tempAssetCode !== "" ||
                                                    this.state.uploadedCount > 0)
                                                ? true
                                                : (title === "EDIT" &&
                                                    filters["client"] &&
                                                    filters["client"].options.disabledOnEdit) ||
                                                false)
                                        }
                                    >
                                        {filters["client"] &&
                                            filters["client"]["data"] &&
                                            filters["client"]["data"]["data"].map(itm => (
                                                <Select.Option key={itm._id} value={itm._id}>
                                                    {itm.name}
                                                </Select.Option>
                                            ))}
                                    </Select>
                                )}
                                {filters["client"] &&
                                    filters["client"].options &&
                                    filters["client"].options.master ? (
                                    <MasterModal
                                        resource={resource}
                                        item={filters["client"].options.ref}
                                        title={"CREATE"}
                                    />
                                ) : (
                                    ""
                                )}
                            </Form.Item>
                            {Object.keys(filters).map(itm => {
                                if (filters[itm].type === "Array" && filters[itm].schema) {
                                    return (
                                        <SubList
                                            changeCountable={this.onChangeCountable}
                                            filters={filters}
                                            ref={this.child}
                                            match={this.props.match}
                                            history={this.props.history}
                                            handleSelectAssetType={this.props.handleSelectAssetType}
                                            handleSelectAssetSubType={
                                                this.props.handleSelectAssetSubType
                                            }
                                            documentData={this.state.documentData}
                                            getDocumentData={this.getDocumentData}
                                            checked={this.state.checked}
                                            key={itm}
                                            item={filters[itm]}
                                            warning={this.props.warning}
                                            assetSubTypes={this.props.assetSubTypes}
                                            assetModels={this.props.assetModels}
                                            updateDocumentData={this.getDocumentData}
                                            updateUploadedState={this.updateUploadedState}
                                            uploaded
                                            form={this.props.form}
                                            tempAssetCode={this.state.tempAssetCode}
                                            tempAssetCodeData={tempAssetCodeData}
                                            searchAssetParameter={this.props.searchAssetParameter}
                                            assetParameterData={this.props.assetParameterData}
                                            data={[{}]}
                                            title={title}
                                            resource={resource}
                                            checkQrAlreadyUsed={this.props.checkQrAlreadyUsed}
                                            qrUsed={this.props.qrUsed}
                                            changeQrAcceptVisible={this.changeQrAcceptVisible}
                                            qrAcceptVisible={this.state.qrAcceptVisible}
                                            allTagTypes={this.props.allTagTypes}
                                            getAllTagTypes={this.props.getAllTagTypes}
                                            width={this.props.width}
                                            lastTagType={this.props.lastTagType}
                                            handleTagTypeChange={this.props.handleTagTypeChange}
                                        />
                                    );
                                }
                            })}
                            <Form.Item>
                                {this.state.documentData && this.state.documentData.length ? (
                                    <Button
                                        type="primary"
                                        className="gx-mb-0"
                                        disabled={data && data.status === "COMPLETED"}
                                        onClick={this.handleSubmitWithDocuments}
                                    >
                                        SAVE & NEXT
                                    </Button>
                                ) : this.state.documentData &&
                                    this.state.documentData.length &&
                                    tempAssetCode !== "" ? (
                                    <Button
                                        type="primary"
                                        className="gx-mb-0"
                                        disabled={data && data.status === "COMPLETED"}
                                        onClick={this.handleSubmitWithDocuments}
                                    >
                                        SAVE & NEXT
                                    </Button>
                                ) : (
                                    <> </>
                                )}
                            </Form.Item>
                            <div>
                                {this.state.documentData && this.state.documentData.length ? (
                                    <Button
                                        type="primary"
                                        className="gx-mb-0"
                                        disabled={data && data.status === "COMPLETED"}
                                        onClick={this.handleDone}
                                    >
                                        SAVE & EXIT
                                    </Button>
                                ) : (
                                    <> </>
                                )}

                                <Button
                                    type="primary"
                                    className="gx-mb-0"
                                    disabled={tempAssetCode !== ""}
                                    onClick={this.handleExit}
                                >
                                    EXIT
                                </Button>
                            </div>
                        </div>
                    </Form>
                </Card>
            </Spin>
        );
    }
}

const CreateForm = Form.create({
    name: "global_state",
    onFieldsChange(props, changedFields) {
        props.onChange(changedFields);
    }
})(Create);

export default geolocated()(CreateForm);
